import { Button, Grid, ScrollArea, Stack, Title } from '@mantine/core';
import React, { useEffect } from 'react';

import { TSDData } from '@e-origin/contracts';

import { DateTimePickerInput, LeavePageNotification, StickyContainer, TextInput } from '@components';
import { TSDPNCarrierSection } from '@features/tsd/TSDView/TSDViewPNData/TSDPNCarrierSection';
import { TSDPNPersonPresentingSection } from '@features/tsd/TSDView/TSDViewPNData/TSDPNPersonPresentingSection';
import { useTsdViewPNDataFormInitializer } from '@features/tsd/TSDView/TSDViewPNData/useTSDViewPNDataFormInitializer';

interface TSDViewPNDataProps {
  tsd: TSDData;
  disabled: boolean;
}

export const TSDViewPNData: React.FC<TSDViewPNDataProps> = ({ tsd, disabled }) => {
  const { form, onSubmit, buildFormValues } = useTsdViewPNDataFormInitializer({ tsd });

  useEffect(() => {
    form.setValues(buildFormValues(tsd));
    form.resetDirty({});
  }, [tsd]);

  return (
    <>
      <LeavePageNotification hasUnsavedChanges={form.isDirty()} />

      <ScrollArea h="100%" offsetScrollbars="y">
        <form onSubmit={form.onSubmit((values) => onSubmit(values))}>
          <Stack mx="xl">
            <Stack mb="xl">
              <Title order={5} fw={600}>
                Presentation data
              </Title>

              <Grid maw={900}>
                <Grid.Col span={{ base: 8, lg: 8, xl: 6 }}>
                  <DateTimePickerInput
                    {...form.getInputProps('generalInfo.dateAndTimeOfPresentationOfTheGoods')}
                    label="Date and time of presentation of the goods"
                    disabled={disabled}
                    size="lg"
                  />
                </Grid.Col>

                <Grid.Col span={{ base: 8, lg: 8, xl: 4 }}>
                  <TextInput
                    {...form.getInputProps('customsOfficeOfPresentation.referenceNumber')}
                    label="Customs office of presentation"
                    disabled={disabled}
                  />
                </Grid.Col>
              </Grid>
            </Stack>

            <TSDPNPersonPresentingSection form={form} disabled={disabled} />

            <TSDPNCarrierSection form={form} disabled={disabled} />
          </Stack>
          <StickyContainer>
            <Button type="submit" disabled={disabled || !form.isValid()} variant="filled" size="lg" data-pw="save-transit-btn">
              Save
            </Button>
          </StickyContainer>
        </form>
      </ScrollArea>
    </>
  );
};
